export default defineNuxtPlugin(() => {
  if ( navigator.userAgent.includes("Windows")) {
    document.documentElement.classList.add("is-windows");
  }
});
